import { Loader2, Trash2 } from "lucide-react";
import { FormEventHandler, ReactNode } from "react";
import { Button } from "../../../../../../components/ui/common/button";

interface TransportDrawerLayoutProps {
  formId: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
  saveDisabled: boolean;
  saveTitle: string;
  deleteDisabled: boolean;
  onDeleteClick: () => void;
  topContent?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

const TransportDrawerLayout = ({
  formId,
  onSubmit,
  saveDisabled,
  saveTitle,
  deleteDisabled,
  onDeleteClick,
  topContent,
  footer,
  children
}: TransportDrawerLayoutProps) => (
  <div className="tw-flex tw-min-h-full tw-w-full tw-flex-col">
    {topContent}

    <form
      id={formId}
      onSubmit={onSubmit}
      className="tw-flex tw-flex-1 tw-flex-col tw-gap-5 tw-w-full tw-pb-20"
    >
      {children}
    </form>

    
    <div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-z-20 tw-border-t tw-border-border tw-bg-background tw-px-4 tw-pb-4 tw-pt-3">
      {footer ?? (
        <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3">
          <Button
            type="button"
            variant="ghost"
            className="tw-border tw-border-destructive/40 tw-text-destructive hover:tw-bg-destructive/10 hover:tw-text-destructive"
            disabled={deleteDisabled}
            onClick={onDeleteClick}
          >
            <Trash2 className="tw-h-4 tw-w-4 tw-mr-1" />
            Delete
          </Button>
          <Button type="submit" form={formId} disabled={saveDisabled}>
            {saveTitle}
          </Button>
        </div>
      )}
    </div>
  </div>
);

export const TransportDrawerLoading = () => (
  <div
    className="tw-flex tw-items-center tw-justify-center tw-py-12"
    aria-busy="true"
    aria-live="polite"
  >
    <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-muted-foreground" />
  </div>
);

export default TransportDrawerLayout;
